const getProductNamesByProductObject = (product) => {
  if (product.product_name) {
    if (Array.isArray(product.product_name)) {
      return product.product_name.join(', ');
    } else {
      return product.product_name;
    }
  } else if (product.brand_name) {
    return product.brand_name;
  } else if (product.generic_name) {
    return product.generic_name;
  }
  return null;
};

export const getUniqueProductNames = (products) => {
  let productNames = [];

  if (!products) {
    return productNames;
  }

  if (!Array.isArray(products)) {
    const productNameByObject = getProductNamesByProductObject(products);
    return productNameByObject ? [productNameByObject] : [];
  }

  productNames = products.reduce((acc, product) => {
    const productName = getProductNamesByProductObject(product);
    return productName ? [...acc, productName] : acc;
  }, []);

  return Array.from(new Set(productNames));
};
